import { render } from "./SentMailPage.vue?vue&type=template&id=975e6ab2&ts=true"
import script from "./SentMailPage.vue?vue&type=script&lang=ts"
export * from "./SentMailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__